import io from 'socket.io-client';
import {
	SOCKET_EMIT,
	SOCKET_SUBSCRIBE
} from './modules/actions';

const socketMiddleware = (url, clientId) => {

	const socket = io(`${url}?clientId=${clientId}`, {
		transports: ['polling', 'websocket']
	});

	return ({ dispatch }) => next => action => {

		if (typeof action === 'function') {
			return next(action);
		}

		let { type, event, packet, off, callback } = action;

		if (event && type === SOCKET_SUBSCRIBE) {
			off && socket.off(event);

			if (callback && typeof callback === 'string') {
				const type = callback;
				callback = payload => {
					dispatch({
						type: type,
						result: payload
					});
				};
			}

			socket.on(event, callback);
		}

		if (event && type === SOCKET_EMIT) {
			socket.emit(event, packet, callback);
			return;
		}

		return next(action);
	};
};

export default socketMiddleware;


// WEBPACK FOOTER //
// ./src/redux/socketMiddleware.js